import React, { useState, useEffect } from "react";
import FarmerForm from "./FarmerForm";
import UseTables from "./Employees2";
import { useHistory, Redirect } from "react-router-dom";
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";
import axios from "axios";

const isISODate = require("is-iso-date");

export default function Farmers(props) {
  const initialTitle = "Farmer";
  const header = "Farmers";
  const initialApiEndpoint = "/farmer";
  const history = useHistory();
  const extraColumns = [
    { name: "name", label: "Full Name", options: { filter: false } },
    { name: "gender", label: "Gender", options: { filter: false } },
    { name: "NIC", label: "NIC", options: { filter: false } },
    { name: "phone", label: "Mobile", options: { filter: false } },
    { name: "address", label: "Address", options: { filter: false } },
    { name: "dateOfBirth", label: "Birth Date", options: { filter: false } },
    { name: "district", label: "District", options: { filter: false } },
    { name: "dsDivision", label: "DS division", options: { filter: false } },
  ];
  // const table = useTables(
  //   initialTitle,
  //   initialApiEndpoint,
  //   extraColumns,
  //   EmployeeForm
  // );

  return (
    <>
      <UseTables
        initialTitle={initialTitle}
        header={header}
        Icon={PersonPinCircleIcon}
        initialApiEndpoint={initialApiEndpoint}
        extraColumns={extraColumns}
        Form={FarmerForm}
        extraFormToOpen={true}
      />
    </>
  );
}
